import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  useCache,
  usePromiseWrapper,
  useStoreSelector,
  useActions,
} from '../../../helpers/hooks';
import { fetchWarning } from '../../../actions/infos';

export default function WarningCard({ id }) {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const warning = useStoreSelector(
    (selector) => {
      try {
        const warning = selector.getWarning(id);

        return warning[language];
      } catch (e) {}
    },
    [language, id]
  );

  const fetchWarningAction = useActions(() => fetchWarning(language, id), [
    language,
    id,
  ]);

  const checkWarningCache = useCache('warning', id, language);

  const [wrappedWarningFetch, warningLoading, warningError] = usePromiseWrapper(
    {
      initPromise() {
        return fetchWarningAction();
      },
      cached() {
        return checkWarningCache();
      },
    }
  );

  useEffect(() => {
    wrappedWarningFetch();
  }, [id, language]);

  if (warningLoading || warningError || !warning) return null;

  return (
    <div className="warning block">
      <h3 className="text--pink">{t('PayWays.Warning')}!</h3>
      <div dangerouslySetInnerHTML={{ __html: warning }} />
    </div>
  );
}
